// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2-ZB7","info":"Note_info__2UKO6","note":"Note_note__zpV96","actions":"Note_actions__Iq1OC"};